import { LiveTripsForSchool } from '../types';

export const transformLiveTripsData = (livetripsData: LiveTripsForSchool[]) => {
  let result: any = [];
  let srNo = 0;
  livetripsData.map((liveTrips: LiveTripsForSchool) => {
    srNo++;
    return result.push({
      No: srNo,
      id: liveTrips.id,
      'Bus Name': liveTrips.busName,
      'License Plate': liveTrips.licensePlateNo,
      Stop: liveTrips.lastStopName,
      'Last Action': liveTrips.stopStatus
    });
  });
  return result;
};
